/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Day_Series_TitleInputs */

const en_platform_day_series_title = /** @type {(inputs: Platform_Day_Series_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series`)
};

const pl_platform_day_series_title = /** @type {(inputs: Platform_Day_Series_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seria`)
};

/**
* | output |
* | --- |
* | "Series" |
*
* @param {Platform_Day_Series_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_day_series_title = /** @type {((inputs?: Platform_Day_Series_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Day_Series_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_day_series_title(inputs)
	return en_platform_day_series_title(inputs)
});